import { render } from "./DocumentActions.vue?vue&type=template&id=0fd62da5&scoped=true"
import script from "./DocumentActions.vue?vue&type=script&lang=ts"
export * from "./DocumentActions.vue?vue&type=script&lang=ts"

import "./DocumentActions.vue?vue&type=style&index=0&id=0fd62da5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0fd62da5"

export default script